import {
  Button,
  Copy,
  Heading,
  Square,
  SvgX,
} from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { Squish } from '@grubhubprod/gh-cookbook-react';
import { CorpUIResponse } from 'src/types/Corp';
import { Modal } from 'src/components/Modal/Modal';
import { getAutoPaymentTerms } from 'src/components/enterprise/EnterprisePayments/EnterprisePayments.utils';
import { getDateFormatFromUTC } from 'src/utilities/formatDate';

interface IEnterpriseAutoPaymentModalProps {
  onSuccess: () => void;
  corp: CorpUIResponse;
  onClose: () => void;
}

export function EnterpriseAutoPaymentModal({
  corp,
  onClose,
  onSuccess,
}: IEnterpriseAutoPaymentModalProps): JSX.Element {
  return (
    <Modal size="md">
      <Button
        variant="tertiary"
        type="button"
        className="closeModalButton"
        onClick={onClose}
      >
        <SvgX aria-label="close" size="24px" />
      </Button>
      <Square inset="md">
        <Copy variant="body" color="success" display="block" textAlign="center">
          Your credit card has been added!
        </Copy>
      </Square>
      <Squish inset="md">
        <Heading variant="h3" textAlign="center">
          Would you like to enable automatic invoice payment with this card?
        </Heading>
      </Squish>
      <Square inset="md">
        <Copy variant="caption" display="block" textAlign="center">
          Your next invoice period will begin{' '}
          {getDateFormatFromUTC(corp.corpNextInvoiceStartDate)} and end{' '}
          {getDateFormatFromUTC(corp.corpNextInvoiceEndDate)}. Auto payment will{' '}
          begin with that invoice on{' '}
          {getDateFormatFromUTC(corp.corpNextAutopay)}{' '}
          {corp.corpInvoicingPeriod
            ? `and occur ${corp.corpInvoicingPeriod.toLowerCase()}`
            : ''}
          .
        </Copy>
      </Square>
      <Square />
      <Squish inset="md">
        <Button block variant="primary" buttonSize="medium" onClick={onSuccess}>
          Enable auto pay
        </Button>
        <Button block variant="tertiary" buttonSize="medium" onClick={onClose}>
          No, I'd like to pay manually
        </Button>
      </Squish>
      <Squish inset="md">
        <Copy variant="caption" color="secondaryText">
          {getAutoPaymentTerms()}
        </Copy>
      </Squish>
    </Modal>
  );
}
